<template>
    <div id="apprenticebByLaws">
        <Headers :headersText='headersText'></Headers>
        <!-- 步骤流程 -->
        <div class="stepPanel">
            <div class="panel">
                <div class="public">
                    <img src="../assets/images/img_12.png" alt="">
                    <span>分享收徒</span>
                </div>
                <img src="../assets/images/img_11.png" alt="" class="rightArrow">
                <div class="public">
                    <img src="../assets/images/img_10.png" alt="">
                    <span>徒弟注册</span>
                </div>
                <img src="../assets/images/img_11.png" alt="" class="rightArrow">                
                <div class="public">
                    <img src="../assets/images/img_09.png" alt="">
                    <span>徒弟完成任务</span>
                </div>
                <img src="../assets/images/img_11.png" alt="" class="rightArrow">                
                <div class="public">
                    <img src="../assets/images/img_08.png" alt="">
                    <span>您获得收益</span>
                </div>
            </div>
        </div>
        <!-- 文字说明 -->
        <div class="boxPadding">
            <div class="textExplain">
                <div>*分享完成后，好友下载注册本应用并且完成至少一个任务，即成为您的徒弟</div>
                <div>*您的徒弟每完成一个任务，您将从他完成的这个任务中得到提成0.6元</div>
                <div>*您从每位徒弟获取到的提成上限为10元</div>
                <div>*分享收徒的人数无限制</div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import Headers from '../components/headersL'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'收徒分享细则',
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #apprenticebByLaws{
        // 步骤流程
        .stepPanel{
            width: 375px;
            height: 50px;
            padding-top: 8px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            .panel{
                width:345px;
                height:100px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,1);
                margin: 0 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                .public{
                    width: 65px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    img{
                        width: 26px;
                        height: 26px;
                    }
                    span{
                        margin-top: 10px;
                        font-size: 13px;
                        color: #151515;
                        font-weight: bold;
                        white-space: nowrap;
                    }
                }
                .rightArrow{
                    width: 20px;
                    height: 11px;
                    position: relative;
                    top: -12px;
                }
            }
        }
        // 文字说明
        .boxPadding{
            padding-bottom: 15px;
            .textExplain{
                width:309px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,1);
                margin: 65px 15px 0;
                padding: 15px 21px 15px 15px;
                div{
                    font-size:13px;
                    font-weight:400;
                    color:#111111;
                    line-height:18px;
                    &:not(:first-of-type){
                        margin-top: 20px;
                    }
                }
            }
        }
        
    }
</style>